export * from './vermerkt.interface';
